<template>
  <div>
    <v-dialog
      width="500"
      v-model="dialog"
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          height="40"
          elevation="0"
          color="primary"
          class="px-8 idea-button"
          ><span class="text-white"> Add idea </span></v-btn
        >
      </template>

      <v-card
        flat
        width="500"
        :style="{
          borderBottom: '3px solid #272727',
          borderLeft: '1px solid #272727',
          borderTop: '1px solid #272727',
          borderRight: '3px solid #272727',
        }"
      >
        <v-sheet
          class="d-flex justify-center align-center py-2"
          color="accent"
          style="font-size: 10pt; font-weight: 600"
        >
          {{ uid ? "Edit post idea" : "New post idea" }}
        </v-sheet>
        <v-divider class="primary"></v-divider>
        <v-window v-model="step">
          <v-window-item :model-value="0">
            <v-textarea
              placeholder="Write your idea here.."
              variant="solo"
              v-model="idea"
              flat
              class="pa-6"
              autofocus
              density="compact"
              style="border-radius: 6px"
              hint="Write as much as possible. Then let Stix AI write a full post for you."
              no-resize
              ref="ideainput"
              rows="10"
              full-width
            ></v-textarea>
            <v-divider></v-divider>
            <v-text-field
              label="Add URL"
              variant="solo"
              v-model="url"
              flat
              density="compact"
              class="mx-6 my-3"
              hide-details
            ></v-text-field>
            <!-- <div class="mx-6 my-2" v-if="!uid">
              <v-btn
                color="primary lighten-2"
                block
                variant="text"
                size="small"
                @click="step = 1"
                >Ask Stix AI for ideas</v-btn
              >
            </div> -->
            <!-- <v-divider></v-divider>
            <v-combobox
              label="Keywords"
              variant="solo"
              style="border-radius: 8px"
              hide-details=""
              class="mx-6 my-2"
              :items="$store.state.ideas.keywords"
              height="50"
              flat
              clearable
              multiple
              v-model="keywords"
              chips
            ></v-combobox
            > -->
            <v-divider></v-divider>
            <v-select
              class="mx-6 my-2"
              label="Category"
              variant="solo"
              v-model="category"
              height="50"
              flat
              item-value="uid"
              clearable
              hide-details=""
              :items="$store.state.posts.categories"
              item-title="name"
            ></v-select>
            <v-divider></v-divider>
            <div class="d-flex pa-4">
              <v-spacer></v-spacer>
              <v-btn
                size="small"
                elevation="0"
                text
                class="px-6 mr-2"
                @click="close"
                >Close</v-btn
              >
              <v-btn
                size="small"
                elevation="0"
                class="px-6"
                color="button"
                @click="save"
                >Save</v-btn
              >
            </div>
          </v-window-item>
          <v-window-item :model-value="1">
            <div class="pa-6">
              <h1>Generate idea ideas</h1>
              <p style="font-size: 11pt">
                Describe to Stix AI on what idea or keywords you would like idea
                suggestions?
              </p>

              <div>
                <p style="font-size: 10px" class="mb-2 mt-4">
                  Subject
                  <v-tooltip bottom color="primary" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon size="small" class="ml-1" v-bind="props"
                        >mdi-information</v-icon
                      >
                    </template>
                    <div class="pa-2">
                      <span class="text-white"
                        >Subject or keywords that is used as input for Stix AI
                        to generate relevant idea suggestions.</span
                      >
                    </div>
                  </v-tooltip>
                </p>
                <div>
                  <v-textarea
                    placeholder="The next big thing in social media"
                    variant="solo"
                    v-model="prompt"
                    flat
                    hide-details=""
                    density="compact"
                    style="border-radius: 6px"
                    bg-color="smoke"
                    hint="Press enter to add"
                    rows="2"
                  ></v-textarea>
                </div>
              </div>
            </div>
            <v-divider></v-divider>
            <div class="d-flex pa-4">
              <v-spacer></v-spacer>
              <v-btn
                elevation="0"
                variant="text"
                class="px-6 mr-2"
                @click="close"
                >Close</v-btn
              >
              <v-btn
                elevation="0"
                variant="text"
                color="button"
                @click="generate"
                >Generate ideas</v-btn
              >
            </div>
          </v-window-item>
          <v-window-item :model-value="2">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-window-item>
          <v-window-item :model-value="3">
            <v-list density="compact" style="border-radius: 8px">
              <v-list-item v-for="(item, i) in idea_items" :key="i">
                <v-text-field
                  variant="solo"
                  flat
                  bg-color="smoke"
                  hide-details=""
                  style="font-size: 10pt; border-radius: 8px"
                  v-model="idea_items[i]"
                  class="my-1"
                >
                  <template v-slot:append-inner>
                    <v-btn
                      v-if="ideas.findIndex((t) => t.idea === item) < 0"
                      size="small"
                      elevation="0"
                      color="button"
                      @click="saveIdea(item)"
                    >
                      Save
                    </v-btn>
                    <v-icon class="px-5" size="20" v-else color="primary"
                      >mdi-check</v-icon
                    >
                  </template>
                </v-text-field>
              </v-list-item>
            </v-list>
            <div class="mx-6 mb-2">
              <v-btn
                color="primary"
                block
                variant="text"
                size="small"
                @click="generate"
                >Load 5 new</v-btn
              >
            </div>
            <v-divider></v-divider>
            <div class="d-flex pa-4">
              <v-btn
                variant="text"
                size="small"
                @click="step = 1"
                prepend-icon="mdi-chevron-left"
              >
                Edit input
              </v-btn>
              <v-spacer></v-spacer>

              <v-btn elevation="0" class="px-6" color="button" @click="close"
                >Close</v-btn
              >
            </div>
          </v-window-item>
        </v-window>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

export default {
  data() {
    return {
      category: null,
      chat: [
        {
          role: "system",
          content: `You are a social media expert. You will be provided with a prompt. Your task is to provide five ideas to write social media posts. Provide output in JSON format as follows: ["idea", "another idea", "another idea", "another idea", "another idea"].`,
        },
      ],
      dialog: false,
      keyword: "",
      prompt: "",
      idea: "",
      keywords: [],
      idea_items: [],
      all_idea_items: [],
      step: 0,
      uid: null,
      url: null,
    };
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      workspace: (state) => state.workspace.workspace,
      loading: (state) => state.loading,
      ideas: (state) => state.ideas.ideas,
    }),
  },

  methods: {
    close() {
      this.idea = "";
      this.keyword = "";
      this.uid = null;
      this.step = 0;
      this.tags = [];
      this.dialog = false;
    },
    enter(v) {
      if (v.key === "Enter") {
        this.save();
      }
    },
    enterIdea(v) {
      if (v.key === "Enter") {
        this.generate();
      }
    },
    edit(t) {
      this.dialog = true;
      this.tags = t.tags;
      this.uid = t.uid;
      this.idea = t.idea;
    },
    async generate() {
      this.step = 2;
      const ideas = httpsCallable(functions, "openaiIdeas");
      let res = await ideas({
        subject: this.prompt,
        audience: this.workspace.about.target,
        brand_voice: this.workspace.preferences.tone,
        exclude: this.all_idea_items.concat(this.ideas.map((t) => t.idea)),
      });
      console.log(res.data);
      this.idea_items = res.data;
      this.all_idea_items = this.all_idea_items.concat(res.data);
      this.$store.commit("setLoading", { type: "ai.ideas", val: false });
      this.step = 3;
    },
    open() {
      this.dialog = true;
    },
    async save() {
      const ideas = httpsCallable(functions, "titleIdea");
      let res = await ideas(this.idea);
      console.log(res.data);
      this.$store.dispatch("saveIdea", {
        uid: this.uid,
        idea: this.idea,
        keywords: this.keywords,
        title: res.data,
        category: this.category,
        created_at: Math.round(Date.now() / 1000),
        created_by: this.userProfile.uid,
        created_by_email: this.userProfile.email,
        url: this.url,
      });
      this.$store.dispatch("fetchIdeas");
      this.close();
    },
    remove(i) {
      this.$store.dispatch("removeTag", this.workspace.keywords[i]);
    },
    async saveIdea(i) {
      console.log(i);
      const ideas = httpsCallable(functions, "titleIdea");
      let res = await ideas(this.idea);

      this.$store.dispatch("saveIdea", {
        idea: i,
        title: res.data,
        uid: null,
        tags: [],
        category: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item_title {
  white-space: normal;
}

.keys {
  gap: 10px;
  flex-wrap: wrap;
}

.idea-button .v-input__slot::before {
  border-bottom: "3px solid #272727";
  border-left: "1px solid #272727";
  border-top: "1px solid #272727";
  border-right: "3px solid #272727";
}
</style>
